import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { AddTypeBO, AddNoteBO } from './client-notes.modal';

@Injectable({
  providedIn: 'root'
})

export class ClientNotesService {
  constructor(public http: HttpClient, public errorService: ErrorService) {
  }
  //   ..................................................TYPE.....................................................................

  getLov(paramsData: URLSearchParams): Observable<any> {
    let url = "api/Lov/GetLovDropDown?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  saveupdatetype
    (saveList: AddTypeBO): Observable<any> {
    let url = "api/NoteType/SaveNoteType";
    return this.http.post<any>(url, saveList, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  delete(params: URLSearchParams) {
    let url = "api/NoteType/DelNoteType?";
    return this.http.delete<any>(url + params).pipe(
      map(data => data),
      catchError(this.errorService.handleError))
  }

  saveupdatenote(savelist: AddNoteBO): Observable<any> {
    let url = "api/ClientNote/SaveCliNote";
    return this.http.post<any>(url, savelist, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError))
  }

  deletenote(params: URLSearchParams) {
    let url = "api/ClientNote/DelCliNote?";
    return this.http.delete<any>(url + params).pipe(
      map(data => data),
      catchError(this.errorService.handleError))
  }

  getTypeDropdown(): Observable<any> {
    let url = "api/NoteType/GetAllNoteTypeDropDown";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  updatenote(Add: AddNoteBO): Observable<any> {
    let url = "api/ClientNote/UpdateCliNotes?";
    return this.http.post<any>(url, Add, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError))
  }
}